// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"143":"app","736":"vendor"}[chunkId] || chunkId) + "." + {"143":"8c5b220b","662":"c1d1f2ac","736":"4812c455"}[chunkId] + ".css";
};